<div *tdLoading="let flightLog; until: flightLog$ | async; type: 'circle'; color: 'accent'">
  <fl-view-flight-log
    *ngIf="flightLog"
    [flightLog]="flightLog"
    [flightSummary]="flightSummary$ | async"
  ></fl-view-flight-log>
</div>
